module.exports = __webpack_public_path__ + "static/media/cardPic.89285510.png";